import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import RenderAvatar from './partials/Avatar'

import style from './style'

import color from '../../../../utils/color'

import ScrollArea from '../../../partials/ScrollArea'

export const UserTable = props => {
  return (
    <ScrollArea
      style={{
        height: `300px`
      }}
    >
      <Col>
        <Row
          className={css(
            style.list.header,
            style[props.theme.name] ? style[props.theme.name].list.header : null
          )}
        />
        {props.users.map((user, index) => (
          <UserRow
            theme={props.theme}
            key={`${index}_${user.id}`}
            onClick={props.onUserClick}
            isActive={user.id === props.activeId}
            {...user}
          />
        ))}
      </Col>
    </ScrollArea>
  )
}

export const UserRow = props => {
  const userHexColor = color.stringToHex(
    `${props.firstName || 'empty'} ${props.lastName || 'empty'}`
  )
  const fontHexColor = color.contrastHex(userHexColor)

  return (
    <Row
      data-userid={props.id}
      onClick={props.onClick}
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null,
        props.isActive
          ? style[props.theme.name]
            ? (style[props.theme.name].list.activeRow, style.list.activeRow)
            : style.list.activeRow
          : null
      )}
    >
      <Col>
        <Row>
          <Col xs='auto'>
            <RenderAvatar
              bgColor={userHexColor}
              textColor={fontHexColor}
              firstName={props.firstName || ' '}
              lastName={props.lastName || ' '}
            />
          </Col>
          <Col>
            <Row>
              <Col>
                <span className={css(style.user.name)}>
                  {`${props.firstName || '<empty>'} ${props.lastName ||
                    '<empty>'}`}
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <span className={css(style.user.email)}>({props.email})</span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col xs='auto' className={`d-flex align-items-center`}>
        <span className={css(style.user.groupCount)}>
          {(props.groups || []).length} groups
        </span>
      </Col>
    </Row>
  )
}

export default UserTable



// WEBPACK FOOTER //
// ./src/components/User/partials/UserTable/index.js